import { AvailabilityService, StockStatus } from "../services/availabilityService";

export default {
    props: {
        label_stock_availability: {
            type: String,
            default: "Stock Availability"
        },
        label_in_stock: {
            type: String,
            default: "In Stock"
        },
        label_available_for_backorder: {
            type: String,
            default: "Available for Backorder"
        },
        label_out_of_stock: {
            type: String,
            default: "Out of Stock"
        }
    },
    data() {
        return {
            stockStatusEnum: StockStatus,
            itemStockCode: {}
        };
    },
    computed: {
        userType() {
            return this.$store ? this.$store.getters["auth/userType"] : "";
        },
        stockItem() {
            let item = this.$store.getters["cart/getComponentByStockCode"](
                this.itemStockCode
            );
            return item ? item : null;
        },
        stockStatus() {
            if (!this.stockItem) {
                return StockStatus.OUT_OF_STOCK;
            }
            const status = AvailabilityService.getStockStatus(
                this.stockItem,
                this.userType,
                window.culture
            );
            return status;
        },
        stockStatusIcon() {
            const icon = AvailabilityService.getStatusClass(this.stockStatus);
            return icon ? `availability ${icon}` : false;
        },
        stockStatusText() {
            const labels = {
                in_stock: this.label_in_stock,
                available_for_backorder: this.label_available_for_backorder,
                out_of_stock: this.label_out_of_stock
            };
            return AvailabilityService.getStatusText(this.stockStatus, labels);
        }
    },
    methods: {}
};
